import {
  CompanyListItemWrapper,
  CompanyListLabel,
  CompanyListLabelWrapper,
  CompanyListSubLabel,
} from 'components/CompanyList/CompanyList.styled';
import {
  CompanyListDataNode,
  ICompanyListItemProps,
} from 'components/CompanyList/CompanyList.types';
import CompanyListIcon from 'components/CompanyList/CompanyListIcon/CompanyListIcon';
import { CompanyListContext } from 'components/NavBar/components/CompanySelector/CompanySelectorModal/CompanySelectorModal';
import { KeyboardEvent, useContext, useMemo } from 'react';

const CompanyListItem = ({
  onChange,
  company,
  ...props
}: ICompanyListItemProps) => {
  const { loadingSites, selected } = useContext(CompanyListContext);

  const loadingItemData = selected === company.node.id && loadingSites;

  const handleClick = () => {
    if (company.node.id === selected && !loadingItemData) {
      return;
    }
    onChange(company.node.id);
  };

  const handleKeyDown = (
    event: KeyboardEvent<HTMLLIElement>,
    currentCompany: CompanyListDataNode,
    disabled: boolean,
  ) => {
    if (disabled) {
      return;
    }
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onChange(currentCompany.node.id);
    }
  };

  const subLabelText = useMemo(() => {
    const siteCount = company?.node?.sites?.length;
    const suffix = siteCount === 1 ? 'site' : 'sites';
    return `${siteCount} ${suffix}`;
  }, [company?.node?.sites?.length]);

  return (
    <CompanyListItemWrapper
      data-testid="company-list-item"
      tabIndex={0}
      aria-disabled={!!selected && selected === company.node.id}
      onClick={handleClick}
      onKeyDown={(event) =>
        handleKeyDown(
          event,
          company,
          company.node.id === selected && !loadingItemData,
        )
      }
      whileHover={
        selected && company.node.id === selected
          ? {}
          : { backgroundColor: 'rgba(0, 151, 168, 0.10)' }
      }
      transition={{
        ease: 'easeInOut',
        duration: 0.3,
      }}
      {...props}
    >
      <CompanyListLabelWrapper>
        <CompanyListLabel>{company?.node?.name}</CompanyListLabel>
        <CompanyListSubLabel>{subLabelText}</CompanyListSubLabel>
      </CompanyListLabelWrapper>

      <CompanyListIcon
        loading={loadingItemData}
        company={company}
        selected={selected}
        disabled={!!selected && selected === company.node.id}
      />
    </CompanyListItemWrapper>
  );
};

export default CompanyListItem;
